import TriggerContext from '../TriggerContext';

export const TriggerContent = ({ id, children }) => (
  <TriggerContext.Consumer>
    {(context) => {
      const trigger = context.getTrigger(id);

      function renderContent() {
        return children instanceof Function
          ? children({
              anchor: trigger.anchor,
              close: trigger.close,
            })
          : children;
      }

      return trigger && trigger.isOpen ? renderContent() : null;
    }}
  </TriggerContext.Consumer>
);
TriggerContent.displayName = 'TriggerContent';

export default TriggerContent;
